export default "<p>\n  declaracao-convenio-federal works!\n</p>\n";